define.alias("shared/helpers/are-equal", "calendar/helpers/are-equal");